<script>
  import InputContainer from "../../../../auto-mps/parts/inputs/InputContainer.svelte";
  import Select from "../../../../auto-mps/parts/inputs/Select.svelte";

  /**
   * @type {string}
   */
  export let name

  /**
   * @type {string|null|undefined}
   */
  export let label

  /**
   * @type {string|null|undefined}
   */
  export let error

  const intervals = [
    "hourly",
    "daily",
    "weekly",
  ]
  const translations = {
    "hourly": "時",
    "daily": "日",
    "weekly": "週"
  }
</script>

<InputContainer>
  <span slot="label">
    {#if label}
      {label}
    {:else}
      <slot/>
    {/if}
  </span>
  <Select name={name}>
    {#each intervals as interval}
      <option value={interval}>{translations[interval]}</option>
    {/each}
  </Select>
  <span class="error" slot="outer">
    {#if error}
      {error}
    {/if}
  </span>
</InputContainer>

<style>
  .error {
    color: red;
    font-size: 0.9rem;
  }
</style>
